import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faSpinner } from '@fortawesome/free-solid-svg-icons';

const ReportHeader = ({ onExportPdf, isExporting, isLoading, totalRegistros }) => {
  return (
    <div className="d-flex justify-content-end mb-3">
      <button
        type="button"
        className="btn btn-sm btn-danger d-inline-flex align-items-center gap-2 px-3 py-2 shadow-none fw-semibold"
        onClick={onExportPdf}
        disabled={isExporting || isLoading || totalRegistros === 0}
        style={{ borderRadius: '8px' }}
      >
        <FontAwesomeIcon icon={isExporting ? faSpinner : faFilePdf} spin={isExporting} />
        <span>{isExporting ? 'Generando PDF...' : 'Exportar PDF'}</span>
      </button>
    </div>
  );
};

export default ReportHeader;
